<template>
  <div class="NoDataFoundWatchlist">
    <div class="text-center no-data-container-watchlist">
      <img class="no-data-img" src="../assets/images/NoNotificationIcon.svg" alt="" />
      <div class="first-head">Your watchlist is Empty!</div>
      <div class="text">Bookmark Expert Recommendations to build your watchlist & track them easily.</div>
      <button class="goToExpertViewButton" @click="goToExpertView()">Browse Expert View</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoDataFoundWatchlist',

  data() {
    return {
      selectedSegment: localStorage.getItem('market_type') ? localStorage.getItem('market_type') : 'equity',
    };
  },

  mounted() {},

  methods: {
    goToExpertView() {
      if (this.selectedSegment == 'options') {
        this.$router.push({ path: '/expert-past-strategy-options' });
      } else {
        this.$router.push({ path: '/experts-past-recommendations' });
      }
    },
  },
};
</script>
  
  

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.NoDataFoundWatchlist {
  .no-data-container-watchlist {
    padding: 10px;
    margin: 50px auto;
  }
  .no-data-img {
    width: 230px;
    margin-top: 35px;
  }
  .first-head {
    font-size: 1rem;
    font-weight: 600;
    margin: 20px 0 10px;
  }
  .text {
    font-size: 12px;
    color: gray;
  }
  .goToExpertViewButton {
    max-width: 300px;
    padding: 12px 20px;
    margin: 15px auto;
    color: $secondary-theme-color;
    font-size: 13px;
    font-weight: 600;
    border-radius: 6px;
    background-color: #e5e6ff;
    border: none;
    cursor: pointer;
  }
  .goToExpertViewButton:hover {
    border: 1px solid;
  }
}
</style>
